var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.56896 3.3442C6.78384 3.14274 7.12136 3.15363 7.32282 3.36852L11.3228 7.63519C11.5151 7.84033 11.5151 8.15957 11.3228 8.36473L7.32282 12.6314C7.12136 12.8463 6.78384 12.8572 6.56896 12.6557C6.35407 12.4542 6.34318 12.1167 6.54464 11.9019L10.2027 7.99996L6.54464 4.09806C6.34318 3.88317 6.35407 3.54565 6.56896 3.3442Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.8a352157e69913ff393bfd455aad6c63.svg";
export { ForwardRef as ReactComponent };